// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ChatV2 message column only — scoped under .chatv2-thread so legacy /Live is untouched.
 *
 * Bubble structure (legacy markup):
 *   .Img-Content-Agent / .Img-Content  ← actual colored shell
 *     .message-text-container
 *       .Message-Content               ← must stay transparent (no second bubble)
 */

.chatv2-thread .ChatMessageComponent-Container,
.chatv2-thread .chatv2-messages {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  background: #fff;
}

.chatv2-thread .MessageComponet-Main {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  /* No side padding here — scrollbar sits at the column edge */
  padding: 0 !important;
  box-sizing: border-box;
}

.chatv2-thread .MessageComponent-Main-02 {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* 16px inset inside the scrollport so avatars clear the scrollbar (Figma) */
  padding: 16px 16px 12px !important;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

/* ---- Chat started divider ---- */
.chatv2-thread .Message-Time-Header,
.chatv2-thread .Message-Time-Header-Ended,
.chatv2-thread .Message-Time-Header-Comment {
  margin-bottom: 24px !important;
  display: flex;
  align-items: center;
  gap: 0;
}

.chatv2-thread .Message-Time-Text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 12px !important;
  background: #fff;
  padding: 4px 10px !important;
  border-radius: 14px;
  box-shadow: 0 0 0 2px #fff;
  color: #148dfd !important;
  margin: 0 !important;
}

.chatv2-thread .cv2-chat-started-label,
.chatv2-thread .cv2-chat-ended-label {
  color: #148dfd !important;
}

.chatv2-thread .cv2-chat-started-time,
.chatv2-thread .cv2-chat-ended-time,
.chatv2-thread .cv2-divider-time {
  color: #556575 !important;
}

.chatv2-thread .Left-Line,
.chatv2-thread .right-Line {
  flex: 1;
  height: 1px;
  background: #e5e9ec;
  border: none;
  min-width: 24px;
}

/* ---- Message group / avatar ---- */
.chatv2-thread .message-group-block {
  margin-bottom: 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  align-items: flex-start !important;
}

/*
 * Bubbles column must take ALL remaining row width (not shrink to content).
 * flex-basis 0 + width 0 is the standard trick so % max-widths on children resolve.
 */
.chatv2-thread .chatv2-bubbles-col {
  flex: 1 1 0;
  width: 0;
  min-width: 0;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  box-sizing: border-box;
}

/* Tight stack — no extra gap under each Message-Container */
.chatv2-thread .message-group-block .Message-Container.agent-message,
.chatv2-thread .message-group-block .Message-Container.user-message {
  margin-bottom: 0 !important;
}

/* Agent (sent) — pin bubbles to the right edge beside the avatar */
.chatv2-thread .message-group-block .Message-Container.agent-message {
  margin-left: auto !important;
  margin-right: 0 !important;
  align-self: flex-end !important;
}

/* Visitor (received) — pin bubbles to the left edge beside the avatar */
.chatv2-thread .message-group-block .Message-Container.user-message {
  margin-right: auto !important;
  margin-left: 0 !important;
  align-self: flex-start !important;
}

.chatv2-thread .chatv2-avatar-wrap {
  flex-shrink: 0;
  width: 32px;
  box-sizing: content-box;
}

.chatv2-thread .message-group-block .Img-Content-Agent,
.chatv2-thread .message-group-block .Img-Content {
  margin-bottom: 4px !important;
}

/* Bubble that sits directly above the timestamp row (also a .Message-Container).
   Avoid \`:last-of-type\` / bare \`:last-child\` — tooltip wrappers are also divs/spans. */
.chatv2-thread .message-group-block .Img-Content-Agent:has(+ .Message-Container),
.chatv2-thread .message-group-block .Img-Content:has(+ .Message-Container) {
  margin-bottom: 0 !important;
}

.chatv2-thread .chatv2-message-skeleton {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.chatv2-thread .chatv2-message-skeleton-row {
  width: 100%;
}

.chatv2-thread .avatarContainer.chatv2-avatar,
.chatv2-thread .chatv2-avatar {
  width: 32px !important;
  height: 32px !important;
  flex-shrink: 0;
  overflow: visible !important;
  border-radius: 0 !important;
  position: relative;
}

.chatv2-thread .chatv2-avatar-inner {
  width: 32px;
  height: 32px;
  position: relative;
  flex-shrink: 0;
}

/* Direct child only: the hover profile card lives inside .chatv2-avatar-inner
   and must keep its own larger avatar size. */
.chatv2-thread .chatv2-avatar > .MuiAvatar-root,
.chatv2-thread .chatv2-avatar-inner > .MuiAvatar-root {
  width: 32px !important;
  height: 32px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 32px !important;
  flex-shrink: 0;
  border-radius: 50% !important;
  overflow: hidden !important;
}

.chatv2-thread .chatv2-avatar .MuiAvatar-root img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}

/* Default agent SVG scales to whatever avatar box contains it */
.chatv2-thread .chatv2-avatar .MuiAvatar-root > svg {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

.chatv2-thread .chatv2-agent-card .MuiAvatar-root {
  width: 72px !important;
  height: 72px !important;
  font-size: 24px !important;
  line-height: 72px !important;
  border-radius: 50% !important;
  overflow: hidden !important;
  flex-shrink: 0;
}

.chatv2-thread .chatv2-status-dot {
  position: absolute !important;
  right: 0 !important;
  bottom: -2px !important;
  width: 10px !important;
  height: 10px !important;
  line-height: 0;
  z-index: 1;
  pointer-events: none;
}

.chatv2-thread .chatv2-status-dot svg {
  width: 10px !important;
  height: 10px !important;
  max-width: 10px !important;
  max-height: 10px !important;
  display: block;
}

.chatv2-thread .Message-Container {
  /* Cap against the bubbles column (definite width) — not a circular % of fit-content */
  max-width: min(472px, 100%);
  width: fit-content;
  min-width: 0;
  gap: 5px;
  box-sizing: border-box;
}

/* Pin agent / visitor bubbles to the correct side even when long text wraps */
.chatv2-thread .Message-Container.agent-message {
  align-self: flex-end;
  margin-left: auto;
}

.chatv2-thread .Message-Container.user-message {
  align-self: flex-start;
  margin-right: auto;
}

/* ---- Outer bubble shell (THIS is the real bubble) ---- */
.chatv2-thread .Img-Content-Agent,
.chatv2-thread .Img-Content {
  /* Parent Message-Container already caps at min(480px, 100%) with a definite % basis */
  width: fit-content !important;
  max-width: 100% !important;
  min-width: 0 !important;
  padding: 16px !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  position: relative;
  box-sizing: border-box;
  overflow-wrap: anywhere;
  word-break: break-word;
  overflow-x: hidden;
  overflow-y: visible;
}

/* Agent — Figma light blue */
.chatv2-thread .Img-Content-Agent {
  background: #d6edff !important;
  color: #061522 !important;
}

/* Visitor — Figma gray */
.chatv2-thread .Img-Content {
  background: #f1f3f5 !important;
  color: #061522 !important;
}

/* Internal note bubble — same pattern as TicketV2 \`.ticket-admin-content\` */
.chatv2-thread .Img-Content-Agent.private-message,
.chatv2-thread .private-message.Img-Content-Agent,
.chatv2-thread .Img-Content.private-message,
.chatv2-thread .private-message.Img-Content {
  background: #fff1b8 !important;
  color: #061522 !important;
  padding: 0 !important;
  overflow: hidden;
  border-radius: 8px !important;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
}

.chatv2-thread .Img-Content-Agent.private-message::before,
.chatv2-thread .private-message.Img-Content-Agent::before,
.chatv2-thread .Img-Content.private-message::before,
.chatv2-thread .private-message.Img-Content::before {
  content: "Internal Note";
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #874d00;
  line-height: 1.2;
  font-family: "Inter", sans-serif;
  background: #fff1b8;
  border-radius: 8px 8px 0 0;
  padding: 10px 16px;
  margin: 0;
  border-bottom: 1px solid #f3e1a6;
  box-sizing: border-box;
}

/* ---- Inner text wrapper: NEVER a second bubble ---- */
.chatv2-thread .message-text-container {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  width: auto;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
  box-sizing: border-box;
}

/* Must follow the general rule so Internal Note body padding wins */
.chatv2-thread .private-message .message-text-container {
  padding: 10px 16px !important;
  box-sizing: border-box;
}

.chatv2-thread .private-message .image-container {
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 10px;
  box-sizing: border-box;
}

/* Attachment image fills bubble width (matches text), not a fixed 180px square */
.chatv2-thread .image-container,
.chatv2-thread .image-container--full {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.chatv2-thread .image-container + .message-text-container {
  margin-top: 8px;
}

.chatv2-thread .image-container .chat-attachment-image {
  width: 100% !important;
  height: auto !important;
  max-height: 320px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}

.chatv2-thread .private-message .Private-Message-Content a,
.chatv2-thread .private-message .Message-Text a,
.chatv2-thread .private-message a {
  color: #148dfd !important;
}

.chatv2-thread .Message-Content,
.chatv2-thread .Private-Message-Content,
.chatv2-thread .agent-message .Message-Content,
.chatv2-thread .user-message .Message-Content {
  background: transparent !important;
  background-color: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  color: #061522 !important;
  font-size: 14px !important;
  line-height: 22px !important;
  font-weight: 400 !important;
  max-width: 100% !important;
  min-width: 0 !important;
  border: none !important;
  width: auto !important;
  overflow-wrap: anywhere !important;
  word-break: break-word !important;
  box-sizing: border-box;
}

.chatv2-thread .Message-Text,
.chatv2-thread .First-Message-Text,
.chatv2-thread .User-message-text {
  color: #061522 !important;
  font-size: 14px !important;
  line-height: 22px !important;
  margin: 0 !important;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  width: auto;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

/* Kill legacy First-Message card chrome inside ChatV2 */
.chatv2-thread .First-Message-Heading {
  background: transparent !important;
  border-radius: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

.chatv2-thread .First-Message-Content {
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  min-width: 0 !important;
  max-width: 100% !important;
  width: auto !important;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
  box-sizing: border-box;
}

/* V2 pre-chat card — must follow the kill rules above */
.chatv2-thread .Img-Content.chatv2-prechat {
  padding: 0 !important;
  overflow: hidden;
  width: 100% !important;
  min-width: 280px !important;
  max-width: 480px !important;
  background: #f1f3f5 !important;
  box-sizing: border-box;
}

.chatv2-thread .chatv2-prechat .First-Message-Heading {
  background: transparent !important;
  border-radius: 0 !important;
  font-family: Inter, sans-serif;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  color: #061522 !important;
  padding: 12px 16px 8px !important;
  margin: 0 !important;
  box-sizing: border-box;
}

.chatv2-thread .chatv2-prechat .message-text-container {
  padding: 0 12px 12px !important;
  margin: 0 !important;
  background: transparent !important;
  width: 100%;
  box-sizing: border-box;
}

.chatv2-thread .chatv2-prechat .First-Message-Content {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border: none !important;
  border-radius: 8px !important;
  min-width: 0 !important;
  max-width: 100% !important;
  width: 100% !important;
  padding: 12px 16px !important;
  margin: 0 !important;
  box-sizing: border-box;
  box-shadow: none !important;
}

.chatv2-thread .chatv2-prechat .First-Message-Text {
  color: #061522 !important;
  font-size: 14px !important;
  line-height: 22px !important;
  margin: 0 !important;
  font-family: Inter, sans-serif;
  display: block;
  width: 100%;
}

.chatv2-thread .chatv2-prechat .First-Message-Text .highlight {
  color: #405261 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  display: block;
  margin-bottom: 2px;
}

.chatv2-thread .chatv2-prechat .First-Message-Text > span:not(.highlight) {
  color: #061522 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  text-transform: none !important;
  word-break: normal !important;
  overflow-wrap: anywhere !important;
  white-space: normal !important;
  display: block !important;
  max-width: 100% !important;
  margin: 0 0 12px !important;
}

.chatv2-thread .chatv2-prechat .First-Message-Text > span:not(.highlight):last-of-type {
  margin-bottom: 0 !important;
}

.chatv2-thread .chatv2-prechat .First-Message-Text br {
  display: none;
}

.chatv2-thread .Img-Content-Agent a,
.chatv2-thread .Img-Content-Agent .Message-Text a {
  color: #148dfd !important;
}

/* ---- Timestamp row under bubble ---- */
.chatv2-thread .User-message-text-down {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 0;
  min-height: 0;
  width: 100%;
}

.chatv2-thread .user-message .User-message-text-down {
  justify-content: flex-start;
}

.chatv2-thread .message-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-direction: row;
}

/* Timestamp row sits outside bubble — size to content, don't stretch/shrink bubble */
.chatv2-thread .Message-Container.agent-message:has(> .User-message-text-down),
.chatv2-thread .Message-Container.user-message:has(> .User-message-text-down) {
  width: fit-content;
  max-width: min(480px, 100%);
  min-width: 0;
  justify-content: inherit;
}

.chatv2-thread .Message-Container.agent-message:has(> .User-message-text-down) {
  align-self: flex-end;
  margin-left: auto;
}

.chatv2-thread .Message-Container.user-message:has(> .User-message-text-down) {
  align-self: flex-start;
  margin-right: auto;
}

.chatv2-thread .User-Messagetime01,
.chatv2-thread .User-Messagetime02,
.chatv2-thread .Agent-Messagetime,
.chatv2-thread .message-time,
.chatv2-thread .User-Messagetime {
  color: #556575 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
  text-align: inherit;
  margin: 0 !important;
  padding: 0 !important;
  white-space: nowrap;
}

.chatv2-thread .tick-icon,
.chatv2-thread .User-message-text-down svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  display: block;
}

/* ---- Composer / tags — same 16px inset as message scroll area ---- */
.chatv2-thread .ChatMessage_Container_Input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 0 16px 8px !important;
  align-items: stretch;
  overflow: visible;
}

.chatv2-thread .ChatMessage_Container_Input > * {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.chatv2-thread .ChatMessage-Footer-Container {
  padding: 0 16px 8px !important;
  margin: 0 !important;
  box-sizing: border-box;
}

.chatv2-thread .ChatMessage-Footer-Container .ChatMessage-Footer {
  margin: 0;
  padding: 0 0 8px !important;
}

/* Archive tags: match Archive-Section (24px), not the 16px composer inset */
.chatv2-thread .ChatMessage-Footer-Container--archive {
  padding: 0 0 8px !important;
  margin: 0 24px !important;
}

.chatv2-thread .Archive-Section {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.chatv2-thread .TypingIndicator,
.chatv2-thread .typing-indicator {
  margin-bottom: 8px;
  padding-left: 0;
  padding-right: 0;
}

/* Composer shell — matches TicketV2 tv2 framed input */
.chatv2-thread .chatv2-composer.ChatMessageInput-Main-Container {
  border: 1px solid #d5dce1;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
  overflow: visible;
  display: flex;
  flex-direction: column;
  min-height: 160px;
  box-sizing: border-box;
}

.chatv2-thread .chatv2-composer.chatv2-composer--internal.ChatMessageInput-Main-Container {
  background: #fffbe6;
  border-color: #f3e1a6;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
}

.chatv2-composer-tabs {
  display: flex;
  align-items: stretch;
  gap: 24px;
  padding: 0 16px;
  border-bottom: 1px solid #e5e9ec;
  background: #fff;
  border-radius: 7px 7px 0 0;
  flex-shrink: 0;
}

.chatv2-composer-tab {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 10px 0;
  margin-bottom: -1px;
  border-bottom: 2px solid transparent;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #405261;
  cursor: pointer;
  line-height: 18px;
}

.chatv2-composer-tab.is-active {
  font-weight: 500;
  color: #061522;
  border-bottom-color: #148dfd;
}

.chatv2-composer-tab.is-disabled,
.chatv2-composer-tab:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  color: #405261;
  border-bottom-color: transparent;
}

.chatv2-composer.chatv2-composer--internal .chatv2-composer-tabs {
  background: #fff1b8;
  border-bottom-color: #f3e1a6;
}

.chatv2-thread .chatv2-composer .ChatMessageInput-Container {
  background: transparent;
}

.chatv2-thread .chatv2-composer.chatv2-composer--internal .ChatMessageInput-Container,
.chatv2-thread .chatv2-composer.chatv2-composer--internal .ChatMessage-Button-Container {
  background: #fffbe6;
}

.chatv2-thread .chatv2-composer .ChatInput {
  background: transparent !important;
  color: #061522;
}

.chatv2-thread .chatv2-composer .ChatInput::placeholder {
  color: #93a1b0;
}

/* V2 tags row — Figma “Tags:” + pills above composer */
.chatv2-thread .ChatMessage-Footer-Container .ChatMessage-Footer {
  margin: 0;
  padding: 0 0 8px;
}

.chatv2-thread .chatv2-tags-label {
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #061522;
  line-height: 14px;
  margin: 0 8px 0 0;
}

.chatv2-thread .ChatMessage-Footer-Container .TicketTag {
  height: 32px;
  border-radius: 16px;
  border: 1px solid #c5ced6;
  background: #f9fafa;
  color: #405261;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);
  padding: 0 8px;
}

.chatv2-thread .chatv2-composer .ChatInput-Button {
  width: 128px;
  min-width: 128px;
  max-width: 128px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  background: #148dfd;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/ChatV2/chatV2MessageOverrides.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,6DAA6D;EAC7D,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4EAA4E;EAC5E,kCAAkC;EAClC,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA,mCAAmC;AACnC;;;EAGE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;;EAGE;AACF;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;;EAEE,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;AACzB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;uFACuF;AACvF;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;8CAC8C;AAC9C;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,sFAAsF;EACtF,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,sBAAsB;AACxB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;;EAEE,sFAAsF;EACtF,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,4EAA4E;AAC5E;;;;EAIE,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;;;EAIE,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,oEAAoE;AACpE;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,kCAAkC;EAClC,wCAAwC;EACxC,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;EAClC,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,oBAAoB;EACpB,8BAA8B;EAC9B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;;;EAKE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA,4EAA4E;AAC5E;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;AACnD","sourcesContent":["/**\n * ChatV2 message column only — scoped under .chatv2-thread so legacy /Live is untouched.\n *\n * Bubble structure (legacy markup):\n *   .Img-Content-Agent / .Img-Content  ← actual colored shell\n *     .message-text-container\n *       .Message-Content               ← must stay transparent (no second bubble)\n */\n\n.chatv2-thread .ChatMessageComponent-Container,\n.chatv2-thread .chatv2-messages {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  background: #fff;\n}\n\n.chatv2-thread .MessageComponet-Main {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  /* No side padding here — scrollbar sits at the column edge */\n  padding: 0 !important;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .MessageComponent-Main-02 {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* 16px inset inside the scrollport so avatars clear the scrollbar (Figma) */\n  padding: 16px 16px 12px !important;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n}\n\n/* ---- Chat started divider ---- */\n.chatv2-thread .Message-Time-Header,\n.chatv2-thread .Message-Time-Header-Ended,\n.chatv2-thread .Message-Time-Header-Comment {\n  margin-bottom: 24px !important;\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n.chatv2-thread .Message-Time-Text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 12px !important;\n  background: #fff;\n  padding: 4px 10px !important;\n  border-radius: 14px;\n  box-shadow: 0 0 0 2px #fff;\n  color: #148dfd !important;\n  margin: 0 !important;\n}\n\n.chatv2-thread .cv2-chat-started-label,\n.chatv2-thread .cv2-chat-ended-label {\n  color: #148dfd !important;\n}\n\n.chatv2-thread .cv2-chat-started-time,\n.chatv2-thread .cv2-chat-ended-time,\n.chatv2-thread .cv2-divider-time {\n  color: #556575 !important;\n}\n\n.chatv2-thread .Left-Line,\n.chatv2-thread .right-Line {\n  flex: 1;\n  height: 1px;\n  background: #e5e9ec;\n  border: none;\n  min-width: 24px;\n}\n\n/* ---- Message group / avatar ---- */\n.chatv2-thread .message-group-block {\n  margin-bottom: 0;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  align-items: flex-start !important;\n}\n\n/*\n * Bubbles column must take ALL remaining row width (not shrink to content).\n * flex-basis 0 + width 0 is the standard trick so % max-widths on children resolve.\n */\n.chatv2-thread .chatv2-bubbles-col {\n  flex: 1 1 0;\n  width: 0;\n  min-width: 0;\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-y: visible;\n  box-sizing: border-box;\n}\n\n/* Tight stack — no extra gap under each Message-Container */\n.chatv2-thread .message-group-block .Message-Container.agent-message,\n.chatv2-thread .message-group-block .Message-Container.user-message {\n  margin-bottom: 0 !important;\n}\n\n/* Agent (sent) — pin bubbles to the right edge beside the avatar */\n.chatv2-thread .message-group-block .Message-Container.agent-message {\n  margin-left: auto !important;\n  margin-right: 0 !important;\n  align-self: flex-end !important;\n}\n\n/* Visitor (received) — pin bubbles to the left edge beside the avatar */\n.chatv2-thread .message-group-block .Message-Container.user-message {\n  margin-right: auto !important;\n  margin-left: 0 !important;\n  align-self: flex-start !important;\n}\n\n.chatv2-thread .chatv2-avatar-wrap {\n  flex-shrink: 0;\n  width: 32px;\n  box-sizing: content-box;\n}\n\n.chatv2-thread .message-group-block .Img-Content-Agent,\n.chatv2-thread .message-group-block .Img-Content {\n  margin-bottom: 4px !important;\n}\n\n/* Bubble that sits directly above the timestamp row (also a .Message-Container).\n   Avoid `:last-of-type` / bare `:last-child` — tooltip wrappers are also divs/spans. */\n.chatv2-thread .message-group-block .Img-Content-Agent:has(+ .Message-Container),\n.chatv2-thread .message-group-block .Img-Content:has(+ .Message-Container) {\n  margin-bottom: 0 !important;\n}\n\n.chatv2-thread .chatv2-message-skeleton {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .chatv2-message-skeleton-row {\n  width: 100%;\n}\n\n.chatv2-thread .avatarContainer.chatv2-avatar,\n.chatv2-thread .chatv2-avatar {\n  width: 32px !important;\n  height: 32px !important;\n  flex-shrink: 0;\n  overflow: visible !important;\n  border-radius: 0 !important;\n  position: relative;\n}\n\n.chatv2-thread .chatv2-avatar-inner {\n  width: 32px;\n  height: 32px;\n  position: relative;\n  flex-shrink: 0;\n}\n\n/* Direct child only: the hover profile card lives inside .chatv2-avatar-inner\n   and must keep its own larger avatar size. */\n.chatv2-thread .chatv2-avatar > .MuiAvatar-root,\n.chatv2-thread .chatv2-avatar-inner > .MuiAvatar-root {\n  width: 32px !important;\n  height: 32px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 32px !important;\n  flex-shrink: 0;\n  border-radius: 50% !important;\n  overflow: hidden !important;\n}\n\n.chatv2-thread .chatv2-avatar .MuiAvatar-root img {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: cover;\n}\n\n/* Default agent SVG scales to whatever avatar box contains it */\n.chatv2-thread .chatv2-avatar .MuiAvatar-root > svg {\n  width: 100% !important;\n  height: 100% !important;\n  display: block;\n}\n\n.chatv2-thread .chatv2-agent-card .MuiAvatar-root {\n  width: 72px !important;\n  height: 72px !important;\n  font-size: 24px !important;\n  line-height: 72px !important;\n  border-radius: 50% !important;\n  overflow: hidden !important;\n  flex-shrink: 0;\n}\n\n.chatv2-thread .chatv2-status-dot {\n  position: absolute !important;\n  right: 0 !important;\n  bottom: -2px !important;\n  width: 10px !important;\n  height: 10px !important;\n  line-height: 0;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.chatv2-thread .chatv2-status-dot svg {\n  width: 10px !important;\n  height: 10px !important;\n  max-width: 10px !important;\n  max-height: 10px !important;\n  display: block;\n}\n\n.chatv2-thread .Message-Container {\n  /* Cap against the bubbles column (definite width) — not a circular % of fit-content */\n  max-width: min(472px, 100%);\n  width: fit-content;\n  min-width: 0;\n  gap: 5px;\n  box-sizing: border-box;\n}\n\n/* Pin agent / visitor bubbles to the correct side even when long text wraps */\n.chatv2-thread .Message-Container.agent-message {\n  align-self: flex-end;\n  margin-left: auto;\n}\n\n.chatv2-thread .Message-Container.user-message {\n  align-self: flex-start;\n  margin-right: auto;\n}\n\n/* ---- Outer bubble shell (THIS is the real bubble) ---- */\n.chatv2-thread .Img-Content-Agent,\n.chatv2-thread .Img-Content {\n  /* Parent Message-Container already caps at min(480px, 100%) with a definite % basis */\n  width: fit-content !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  padding: 16px !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n  position: relative;\n  box-sizing: border-box;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n/* Agent — Figma light blue */\n.chatv2-thread .Img-Content-Agent {\n  background: #d6edff !important;\n  color: #061522 !important;\n}\n\n/* Visitor — Figma gray */\n.chatv2-thread .Img-Content {\n  background: #f1f3f5 !important;\n  color: #061522 !important;\n}\n\n/* Internal note bubble — same pattern as TicketV2 `.ticket-admin-content` */\n.chatv2-thread .Img-Content-Agent.private-message,\n.chatv2-thread .private-message.Img-Content-Agent,\n.chatv2-thread .Img-Content.private-message,\n.chatv2-thread .private-message.Img-Content {\n  background: #fff1b8 !important;\n  color: #061522 !important;\n  padding: 0 !important;\n  overflow: hidden;\n  border-radius: 8px !important;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n}\n\n.chatv2-thread .Img-Content-Agent.private-message::before,\n.chatv2-thread .private-message.Img-Content-Agent::before,\n.chatv2-thread .Img-Content.private-message::before,\n.chatv2-thread .private-message.Img-Content::before {\n  content: \"Internal Note\";\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: #874d00;\n  line-height: 1.2;\n  font-family: \"Inter\", sans-serif;\n  background: #fff1b8;\n  border-radius: 8px 8px 0 0;\n  padding: 10px 16px;\n  margin: 0;\n  border-bottom: 1px solid #f3e1a6;\n  box-sizing: border-box;\n}\n\n/* ---- Inner text wrapper: NEVER a second bubble ---- */\n.chatv2-thread .message-text-container {\n  padding: 0 !important;\n  margin: 0 !important;\n  background: transparent !important;\n  width: auto;\n  max-width: 100%;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  box-sizing: border-box;\n}\n\n/* Must follow the general rule so Internal Note body padding wins */\n.chatv2-thread .private-message .message-text-container {\n  padding: 10px 16px !important;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .private-message .image-container {\n  padding-left: 12px;\n  padding-right: 12px;\n  padding-bottom: 10px;\n  box-sizing: border-box;\n}\n\n/* Attachment image fills bubble width (matches text), not a fixed 180px square */\n.chatv2-thread .image-container,\n.chatv2-thread .image-container--full {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .image-container + .message-text-container {\n  margin-top: 8px;\n}\n\n.chatv2-thread .image-container .chat-attachment-image {\n  width: 100% !important;\n  height: auto !important;\n  max-height: 320px;\n  object-fit: cover;\n  border-radius: 8px;\n  display: block;\n}\n\n.chatv2-thread .private-message .Private-Message-Content a,\n.chatv2-thread .private-message .Message-Text a,\n.chatv2-thread .private-message a {\n  color: #148dfd !important;\n}\n\n.chatv2-thread .Message-Content,\n.chatv2-thread .Private-Message-Content,\n.chatv2-thread .agent-message .Message-Content,\n.chatv2-thread .user-message .Message-Content {\n  background: transparent !important;\n  background-color: transparent !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  color: #061522 !important;\n  font-size: 14px !important;\n  line-height: 22px !important;\n  font-weight: 400 !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  border: none !important;\n  width: auto !important;\n  overflow-wrap: anywhere !important;\n  word-break: break-word !important;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .Message-Text,\n.chatv2-thread .First-Message-Text,\n.chatv2-thread .User-message-text {\n  color: #061522 !important;\n  font-size: 14px !important;\n  line-height: 22px !important;\n  margin: 0 !important;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  width: auto;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n/* Kill legacy First-Message card chrome inside ChatV2 */\n.chatv2-thread .First-Message-Heading {\n  background: transparent !important;\n  border-radius: 0 !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.chatv2-thread .First-Message-Content {\n  background: transparent !important;\n  background-color: transparent !important;\n  border: none !important;\n  border-radius: 0 !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  width: auto !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  box-shadow: none !important;\n  box-sizing: border-box;\n}\n\n/* V2 pre-chat card — must follow the kill rules above */\n.chatv2-thread .Img-Content.chatv2-prechat {\n  padding: 0 !important;\n  overflow: hidden;\n  width: 100% !important;\n  min-width: 280px !important;\n  max-width: 480px !important;\n  background: #f1f3f5 !important;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Heading {\n  background: transparent !important;\n  border-radius: 0 !important;\n  font-family: Inter, sans-serif;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 22px !important;\n  color: #061522 !important;\n  padding: 12px 16px 8px !important;\n  margin: 0 !important;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .chatv2-prechat .message-text-container {\n  padding: 0 12px 12px !important;\n  margin: 0 !important;\n  background: transparent !important;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Content {\n  background: #ffffff !important;\n  background-color: #ffffff !important;\n  border: none !important;\n  border-radius: 8px !important;\n  min-width: 0 !important;\n  max-width: 100% !important;\n  width: 100% !important;\n  padding: 12px 16px !important;\n  margin: 0 !important;\n  box-sizing: border-box;\n  box-shadow: none !important;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Text {\n  color: #061522 !important;\n  font-size: 14px !important;\n  line-height: 22px !important;\n  margin: 0 !important;\n  font-family: Inter, sans-serif;\n  display: block;\n  width: 100%;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Text .highlight {\n  color: #405261 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 16px !important;\n  display: block;\n  margin-bottom: 2px;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Text > span:not(.highlight) {\n  color: #061522 !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 22px !important;\n  text-transform: none !important;\n  word-break: normal !important;\n  overflow-wrap: anywhere !important;\n  white-space: normal !important;\n  display: block !important;\n  max-width: 100% !important;\n  margin: 0 0 12px !important;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Text > span:not(.highlight):last-of-type {\n  margin-bottom: 0 !important;\n}\n\n.chatv2-thread .chatv2-prechat .First-Message-Text br {\n  display: none;\n}\n\n.chatv2-thread .Img-Content-Agent a,\n.chatv2-thread .Img-Content-Agent .Message-Text a {\n  color: #148dfd !important;\n}\n\n/* ---- Timestamp row under bubble ---- */\n.chatv2-thread .User-message-text-down {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-top: 0;\n  min-height: 0;\n  width: 100%;\n}\n\n.chatv2-thread .user-message .User-message-text-down {\n  justify-content: flex-start;\n}\n\n.chatv2-thread .message-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-direction: row;\n}\n\n/* Timestamp row sits outside bubble — size to content, don't stretch/shrink bubble */\n.chatv2-thread .Message-Container.agent-message:has(> .User-message-text-down),\n.chatv2-thread .Message-Container.user-message:has(> .User-message-text-down) {\n  width: fit-content;\n  max-width: min(480px, 100%);\n  min-width: 0;\n  justify-content: inherit;\n}\n\n.chatv2-thread .Message-Container.agent-message:has(> .User-message-text-down) {\n  align-self: flex-end;\n  margin-left: auto;\n}\n\n.chatv2-thread .Message-Container.user-message:has(> .User-message-text-down) {\n  align-self: flex-start;\n  margin-right: auto;\n}\n\n.chatv2-thread .User-Messagetime01,\n.chatv2-thread .User-Messagetime02,\n.chatv2-thread .Agent-Messagetime,\n.chatv2-thread .message-time,\n.chatv2-thread .User-Messagetime {\n  color: #556575 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  line-height: 16px !important;\n  text-align: inherit;\n  margin: 0 !important;\n  padding: 0 !important;\n  white-space: nowrap;\n}\n\n.chatv2-thread .tick-icon,\n.chatv2-thread .User-message-text-down svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  display: block;\n}\n\n/* ---- Composer / tags — same 16px inset as message scroll area ---- */\n.chatv2-thread .ChatMessage_Container_Input {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  padding: 0 16px 8px !important;\n  align-items: stretch;\n  overflow: visible;\n}\n\n.chatv2-thread .ChatMessage_Container_Input > * {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.chatv2-thread .ChatMessage-Footer-Container {\n  padding: 0 16px 8px !important;\n  margin: 0 !important;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .ChatMessage-Footer-Container .ChatMessage-Footer {\n  margin: 0;\n  padding: 0 0 8px !important;\n}\n\n/* Archive tags: match Archive-Section (24px), not the 16px composer inset */\n.chatv2-thread .ChatMessage-Footer-Container--archive {\n  padding: 0 0 8px !important;\n  margin: 0 24px !important;\n}\n\n.chatv2-thread .Archive-Section {\n  margin-left: 16px !important;\n  margin-right: 16px !important;\n}\n\n.chatv2-thread .TypingIndicator,\n.chatv2-thread .typing-indicator {\n  margin-bottom: 8px;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/* Composer shell — matches TicketV2 tv2 framed input */\n.chatv2-thread .chatv2-composer.ChatMessageInput-Main-Container {\n  border: 1px solid #d5dce1;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: none;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n  min-height: 160px;\n  box-sizing: border-box;\n}\n\n.chatv2-thread .chatv2-composer.chatv2-composer--internal.ChatMessageInput-Main-Container {\n  background: #fffbe6;\n  border-color: #f3e1a6;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n}\n\n.chatv2-composer-tabs {\n  display: flex;\n  align-items: stretch;\n  gap: 24px;\n  padding: 0 16px;\n  border-bottom: 1px solid #e5e9ec;\n  background: #fff;\n  border-radius: 7px 7px 0 0;\n  flex-shrink: 0;\n}\n\n.chatv2-composer-tab {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  padding: 10px 0;\n  margin-bottom: -1px;\n  border-bottom: 2px solid transparent;\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  color: #405261;\n  cursor: pointer;\n  line-height: 18px;\n}\n\n.chatv2-composer-tab.is-active {\n  font-weight: 500;\n  color: #061522;\n  border-bottom-color: #148dfd;\n}\n\n.chatv2-composer-tab.is-disabled,\n.chatv2-composer-tab:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n  color: #405261;\n  border-bottom-color: transparent;\n}\n\n.chatv2-composer.chatv2-composer--internal .chatv2-composer-tabs {\n  background: #fff1b8;\n  border-bottom-color: #f3e1a6;\n}\n\n.chatv2-thread .chatv2-composer .ChatMessageInput-Container {\n  background: transparent;\n}\n\n.chatv2-thread .chatv2-composer.chatv2-composer--internal .ChatMessageInput-Container,\n.chatv2-thread .chatv2-composer.chatv2-composer--internal .ChatMessage-Button-Container {\n  background: #fffbe6;\n}\n\n.chatv2-thread .chatv2-composer .ChatInput {\n  background: transparent !important;\n  color: #061522;\n}\n\n.chatv2-thread .chatv2-composer .ChatInput::placeholder {\n  color: #93a1b0;\n}\n\n/* V2 tags row — Figma “Tags:” + pills above composer */\n.chatv2-thread .ChatMessage-Footer-Container .ChatMessage-Footer {\n  margin: 0;\n  padding: 0 0 8px;\n}\n\n.chatv2-thread .chatv2-tags-label {\n  font-family: Inter, sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  color: #061522;\n  line-height: 14px;\n  margin: 0 8px 0 0;\n}\n\n.chatv2-thread .ChatMessage-Footer-Container .TicketTag {\n  height: 32px;\n  border-radius: 16px;\n  border: 1px solid #c5ced6;\n  background: #f9fafa;\n  color: #405261;\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 1px 2px 0 rgba(6, 21, 34, 0.05);\n  padding: 0 8px;\n}\n\n.chatv2-thread .chatv2-composer .ChatInput-Button {\n  width: 128px;\n  min-width: 128px;\n  max-width: 128px;\n  height: 40px;\n  padding: 0;\n  border-radius: 8px;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  background: #148dfd;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
